<template>
  <el-container class="EstimationForm">
    <el-main style="overflow:hidden;" class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-80"
        :model="data"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="거래처" prop="customer_id">
              <ACustomerSelector
                v-model="data.customer_name"
                seller
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="사업장" prop="location">
              <el-input v-model="data.location" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="전화번호" prop="tel">
              <el-input v-model="data.tel" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="도착지" prop="addr">
              <el-input v-model="data.addr" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="견적일" prop="estimate_date">
              <ADatePicker v-model="data.estimate_date" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="유효일" prop="valid_date">
              <ADatePicker v-model="data.valid_date" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ATradeTable
        ref="trade"
        :items="data.details"
        :customer="customer"
        :disabled="disabled"
        showSaleOnly
        showSpecification
        @changedSum="handleChangedSum"
      />
      <el-dialog
        custom-class="form-dialog"
        top="0"
        :width="showPyungProcessingCost ? '1200px' : '800px'"
        :title="printOption"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
        destroyOnClose
      >
        <ContractMultiPrint
          ref="print"
          v-if="dialogVisible"
          :title="printOption"
          :data="copiedData"
          :estimation_date_flag="estimation_date_flag"
          :customer="customer"
          @completed="handleCompletePrint"
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="activeResisterButton || !has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        :loading="button_loading"
        >{{
          is_new ? $t("button.register") : $t("button.modify")
        }}
        (F4)</el-button
      >
      <el-button
        :disabled="disabled || !has_grant_write"
        v-show="!is_new"
        @click="handleCopyRegister"
        >복사 등록</el-button
      >
      <el-button :disabled="activeResisterButton" @click="handleClickClear"
        >초기화</el-button
      >
      <div v-if="!is_new" class="inline print-option ml-default">
        <el-select v-model="printOption">
          <el-option
            v-for="o in printOptions"
            :key="o.value"
            :value="o.value"
          />
        </el-select>
      </div>
      <el-button v-if="!is_new" class="ml-default" @click="handleClickPrint"
        >인쇄</el-button
      >
      <el-button
        v-if="!is_new"
        :disabled="!has_grant_write"
        type="danger"
        @click="clickDel"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { enter_tab } from "@/common/mixins/enter_tab";
import { company_info } from "@/common/mixins/company_info";
import ContractMultiPrint from "./ContractMultiPrint";

export default {
  name: "EstimationForm",
  components: { ContractMultiPrint },
  mixins: [form, enter_tab, company_info],
  data() {
    var validateValidDate = (rule, value, callback) => {
      if (!value || !this.data.estimate_date) {
        callback();
        return;
      }
      if (value < this.data.estimate_date) {
        callback(new Error("견적일보다 빠릅니다."));
      } else {
        callback();
      }
    };
    return {
      company: {
        show_pyung_processing_cost: false
      },
      sum: 0,
      rules: {
        customer_id: [{ required: true, message: "거래처를 선택해 주세요." }],
        estimate_date: [{ required: true, message: "견적일을 선택해 주세요." }],
        valid_date: [
          { required: true, message: "유효일을 선택해 주세요." },
          { validator: validateValidDate, trigger: ["blur", "change"] },
        ],
      },
      estimation_date_flag: true,
      dialogVisible: false,
      printOption: "견적서",
      customer: {},
      button_loading: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          addr: "",
          code: "",
          customer_id: 0,
          estimate_date: this.util.getDate(0),
          valid_date: this.util.getDate(30),
          location: "",
          customer_name: "",
          price: 0,
          product_name: "",
          tel: "",
          total_price: 0,
          user_id: null,
          details: [],
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_customer"]),
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    is_new() {
      return this.data.id < 1;
    },
    disabled() {
      return !this.customer;
    },
    activeResisterButton() {
      if (this.data.customer_id && this.sum !== 0) {
        return false;
      }
      return true;
    },
    invalid_details() {
      let invalid_index = [];
      this.getDetails().forEach((d) => {
        if (d.product_name && !d.product_id && !d.option_id) {
          return invalid_index.push(d.seq);
        }
      });
      return invalid_index;
    },
    printOptions() {
      return [
        { value: "견적서" },
        { value: "영수증" },
        { value: "거래명세표" },
      ];
    },
    copiedData() {
      return this.util.clone(this.data);
    },
  },
  watch: {
    data: function(val) {
      this.customer = this.table_customer.find((c) => c.id === val.customer_id);
    },
    table_config() {
      this.loadConfig()
    },
  },
  mounted() {
    this.loadConfig()
    if (this.data) {
      this.customer = this.table_customer.find(
        (c) => c.id === this.data.customer_id
      );
    }
  },
  methods: {
    handleClickRegister() {
      if (!this.has_grant_write) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.is_new && this.util.isPastDate(this.data.estimate_date)) {
          this.util.confirm(
            this,
            this.title,
            "견적일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }
        this.doRegister();
      });
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.data.customer_id = null;
        this.data.customer_name = c;
        this.data.location = "";
        this.data.tel = "";
        this.data.addr = "";
      } else {
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;
        this.data.location = c.location;
        this.data.tel = c.tel || c.tel2 || c.owner_tel;
        this.data.addr = this.util.getCustomerAddress(c);
        this.customer = c;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    getDetails(getPerAmount = false) {
      const trades = this.$refs.trade.result();
      const details = [];
      //let product_name = '';
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_id && !trades[i].amount) {
          continue;
        }
        let detail = Object.assign({}, trades[i]);
        if (!detail.cost) {
          detail.cost = 0;
        }
        if (!detail.supply_price) {
          detail.supply_price = 0;
        }
        if (!detail.tax) {
          detail.tax = 0;
        }
        if (!detail.price) {
          detail.price = 0;
        }
        if (!detail.specification || detail.specification.length < 1) {
          detail.specification = null;
        }
        if (getPerAmount) {
          if (detail.specification) {
            let machine_amount = 0;
            detail.specification.forEach((s) => {
              let machine_detail = details.find((d) => d.seq === s);
              if (machine_detail) {
                machine_amount += Number.parseFloat(machine_detail.amount);
              }
            });
            detail.per_amount = detail.amount / machine_amount;
          } else {
            detail.per_amount = detail.amount;
          }
        }
        // detail.seq = i + 1;
        details.push(detail);
      }
      return details;
    },
    doRegister() {
      this.button_loading = true;
      let details = this.getDetails();
      if (details.length < 1) {
        this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
        return;
      }
      let isExistSpecification = true;
      let isMachineNoSpecification = true;
      let isAvailSpecificationAmount = true;
      let machine_amount = 0;
      details.forEach((d) => {
        if (!d.specification) {
          return true;
        }
        machine_amount = 0;
        d.specification.forEach((s) => {
          let machine_spec = details.find((d2) => d2.seq === s);
          if (!machine_spec) {
            //사양 항목에 품목이 입력되어 있는지
            isExistSpecification = false;
          } else if (
            machine_spec.specification &&
            machine_spec.specification.length > 0
          ) {
            //사양 항목이 또 다른 사양이 아닌지
            isMachineNoSpecification = false;
          } else {
            machine_amount += Number.parseFloat(machine_spec.amount);
          }
        });
        if (isExistSpecification && isMachineNoSpecification) {
          //현재 수량이 사양 합계의 배수인지 확인
          if (d.amount % machine_amount !== 0) {
            isAvailSpecificationAmount = false;
          }
        }
      });
      if (!isExistSpecification) {
        this.util.notify_warning(this, this.title, "사양이 비어 있습니다.");
        return;
      }
      if (!isMachineNoSpecification) {
        this.util.notify_warning(
          this,
          this.title,
          "사양이 올바르게 선택되지 않았습니다."
        );
        return;
      }
      if (!isAvailSpecificationAmount) {
        this.util.notify_warning(
          this,
          this.title,
          "사양 수량이 올바르지 않습니다."
        );
        return;
      }
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      // data.estimate_date = this.util.getDateString(data.estimate_date);
      // data.valid_date = this.util.getDateString(data.valid_date);

      // data.product_name = product_name;
      data.details = details;
      if (this.is_new) {
        this.api.createEstimation(data).then((res) => {
          this.button_loading = false;
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("create", "등록되었습니다.");
          }
        });
      } else {
        this.api.updateEstimation(data).then((res) => {
          this.button_loading = false;
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("update", "수정되었습니다.");
          }
        });
      }
    },
    clickDel() {
      this.util.confirm_delete(
        this,
        "견적[" + this.data.code + "]",
        this.doDelete
      );
    },
    doDelete() {
      const data = this.organizeData();
      this.api.deleteEstimation(data).then((res) => {
        if (res.error !== this.system.noError) {
          this.notifyError(res.message);
        } else {
          this.completed("delete", "삭제되었습니다.");
        }
      });
    },
    /** 데이터 값 정리 */
    organizeData() {
      let param = Object.assign({}, this.data);
      param.crn = this.util.remove_dash(param.crn);
      param.ssn = this.util.remove_dash(param.ssn);
      return param;
    },
    notifyError(message) {
      this.util.notify_error(this, "견적", message);
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", "견적", message);
      this.$emit("completed", action, options);
    },
    handleClickClear() {
      // this.$refs.trade.clear();
      this.data.id = 0;
      this.data.estimate_date = this.util.getDate(0);
      this.data.valid_date = this.util.getDate(30);
      this.data.details = [];
    },
    handleClickPrint() {
      this.dialogVisible = true;
    },
    handleCompletePrint() {
      this.dialogVisible = false;
    },
    handleCopyRegister() {
      this.data.id = 0;
      this.data.code = "";
      this.data.details.forEach((item) => {
        item.id = null;
        item.contract_id = null;
        item.status_flag = "0";
      });
    },
  },
};
</script>
